(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["service-detail-page"]) return;
  try {
    
(function(){
  const track = document.querySelector('.custom-service-detail-page-carousel-track');
  const slides = Array.from(track.children);
  const prev = document.querySelector('.custom-service-detail-page-prev');
  const next = document.querySelector('.custom-service-detail-page-next');
  const dots = Array.from(document.querySelectorAll('.custom-service-detail-page-dot'));
  let current = 0;

  function updateSize(){
    const w = document.querySelector('.custom-service-detail-page-carousel-wrap').clientWidth;
    slides.forEach(sl => sl.style.minWidth = w + 'px');
    track.style.transform = `translateX(${-(current * w)}px)`;
  }

  function goTo(i){
    current = (i + slides.length) % slides.length; // handle wrap around
    const w = document.querySelector('.custom-service-detail-page-carousel-wrap').clientWidth;
    track.style.transform = `translateX(${-(current * w)}px)`;
    dots.forEach(d => d.classList.remove('custom-service-detail-page-active'));
    dots[current].classList.add('custom-service-detail-page-active');
  }

  if(prev) prev.onclick = () => goTo(current - 1);
  if(next) next.onclick = () => goTo(current + 1);
  dots.forEach(d => d.onclick = () => goTo(parseInt(d.dataset.index)));

  window.addEventListener('resize', updateSize);
  window.addEventListener('load', updateSize);

  document.querySelectorAll('.custom-service-detail-page-acc-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      item.classList.toggle('custom-service-detail-page-acc-open');
      const sign = btn.querySelector('span');
      sign.textContent = item.classList.contains('custom-service-detail-page-acc-open') ? '-' : '+';
    });
  });

  // ✅ Auto-scroll every 3 seconds
  setInterval(() => {
    goTo(current + 1);
  }, 3000);

})();

  } catch(e) { console.error(e); }
})();
})();
